export enum AmbassadorAffiliateReferencePayoutStatus {
    NOT_SET,
    PENDING,
    PROCESSING,
    COMPLETED,
    UNDER_REVIEW,
    DECLINED,
    FAILED
}